/* global axios */
import ApiClient from './ApiClient';

// Tabelas de preço da IA comercial (backend: Api::V1::Accounts::Ai::
// DataTablesController + nested fields/rows + publish). Admin-only.
class AiDataTables extends ApiClient {
  constructor() {
    super('ai/data_tables', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { data_table: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { data_table: data });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  createField(tableId, data) {
    return axios.post(`${this.url}/${tableId}/fields`, { field: data });
  }

  updateField(tableId, fieldId, data) {
    return axios.patch(`${this.url}/${tableId}/fields/${fieldId}`, {
      field: data,
    });
  }

  destroyField(tableId, fieldId) {
    return axios.delete(`${this.url}/${tableId}/fields/${fieldId}`);
  }

  createRow(tableId, data) {
    return axios.post(`${this.url}/${tableId}/rows`, { row: data });
  }

  updateRow(tableId, rowId, data) {
    return axios.patch(`${this.url}/${tableId}/rows/${rowId}`, { row: data });
  }

  destroyRow(tableId, rowId) {
    return axios.delete(`${this.url}/${tableId}/rows/${rowId}`);
  }
}

export default new AiDataTables();
